import { A as ARIA } from './constants-dbaf23dd.js';

const getAriaDescribedById = (nesId, helpText, error, required) => {
  let describedBy = "";
  if (nesId && (helpText || error || !Boolean(required))) {
    if (helpText) {
      describedBy += nesId + ARIA.helpText + " ";
    }
    if (error) {
      describedBy += nesId + ARIA.error + " ";
    }
    if (!Boolean(required)) {
      describedBy += nesId + ARIA.optional + " ";
    }
  }
  else {
    describedBy = null;
  }
  return describedBy;
};

export { getAriaDescribedById as g };
